export default __webpack_public_path__ + "static/media/vire19.f0a06cbb.jpg";